// extracted by mini-css-extract-plugin
export default {"bodyLogin":"SignUp_bodyLogin__3tmxU","pass":"SignUp_pass__3f5MY"};